import EmptyIncident from './EmptyIncident.view';
export default EmptyIncident;
